import { VERSION } from "./versions";

/**
 * Keys of the VERSION object in versions.ts.
 */
export type VersionKey = keyof typeof VERSION;

/**
 * Mapping of VERSION keys that are backed by an npm package and eligible
 * for auto-update. Only these keys should be updated by version-update
 * automation; others (e.g. NODE_WORKFLOWS) are skipped.
 *
 * @see {@link VERSION_KEYS_SKIP} for keys that must not be auto-updated.
 */
export const VERSION_NPM_PACKAGES: ReadonlyArray<{
  key: VersionKey;
  npmPackage: string;
}> = [
  { key: "ASTRO_VERSION", npmPackage: "astro" },
  { key: "AWS_CDK_CLI_VERSION", npmPackage: "aws-cdk" },
  { key: "AWS_CDK_LIB_VERSION", npmPackage: "aws-cdk-lib" },
  { key: "AWS_CONSTRUCTS_VERSION", npmPackage: "constructs" },
  { key: "PNPM_VERSION", npmPackage: "pnpm" },
  { key: "PROJEN_VERSION", npmPackage: "projen" },
  { key: "SHARP_VERSION", npmPackage: "sharp" },
  { key: "STARLIGHT_VERSION", npmPackage: "@astrojs/starlight" },
  { key: "TURBO_VERSION", npmPackage: "turbo" },
  { key: "TYPES_NODE_VERSION", npmPackage: "@types/node" },
  { key: "VITEST_VERSION", npmPackage: "vitest" },
] as const;

/**
 * VERSION keys that are not backed by npm or must be skipped by
 * auto-update (e.g. runtime versions like Node.js).
 */
export const VERSION_KEYS_SKIP: ReadonlyArray<VersionKey> = ["NODE_WORKFLOWS"];
